<template>
  <div class="managingPeople hp100 bbox " v-loading="loading">

    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex" justify="space-between">
        <el-col>
          <el-button class="add-column-btn" @click="toImport">导入店内菜品</el-button>
        </el-col>
      </el-row>
      <!-- 用户列表区域 -->
      <div :style="{ height: height + 'px' }" style=" margin-top: 20px;">
        <!--        <el-scrollbar style="height: 100%; width: 100%">-->
        <el-row :gutter="20" style="width: 100%">
          <el-col :span="4">
            <div class="typeBox" :style="{ height: height + 'px' }">
              <div v-for="(item, index) in typeList" :key="index"
                   :class="index === typeIndex ? 'active' : ''" class="typeItem"
                   @click="SelectProductType(item.categoryCode,index)">
                {{ item.categoryName }}
              </div>
            </div>
          </el-col>
          <el-col :span="20">
            <el-row :gutter="20" type="flex" justify="space-between">
              <el-col>
                <el-form :inline="true" class="demo-form-inline">
                  <el-form-item label="菜品名称：">
                    <el-input v-model="queryInfo.condition.productName" clearable placeholder="请输入菜品名称"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button class="add-column-btn" @click="getListData()">查询</el-button>
                    <el-button class="dayin-column-btn">重置</el-button>
                  </el-form-item>
                </el-form>
              </el-col>
            </el-row>
            <el-scrollbar style="height: 480px; width: 100%">
              <el-table :data="tableData" border fit highlight-current-row style="width: 100%">
                <el-table-column
                  type="index"
                  :index="sequence()"
                  label="序号"
                  width="100"
                  align="center"
                >
                </el-table-column>
                <el-table-column label="菜品名称" align="center" prop="name">
                </el-table-column>
                <el-table-column label="菜品分类" align="center" prop="categoryName">
                </el-table-column>
                <el-table-column label="菜品售价" align="center" prop="price">
                </el-table-column>
                <el-table-column label="菜品折扣价" align="center" prop="unit">
                </el-table-column>
                <el-table-column label="图片" align="center" prop="imageHash">
                  <template slot-scope="scope">
                    <el-avatar shape="square" :size="50" :src="scope.row.imageHash"></el-avatar>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="200">
                  <template slot-scope="scope">
                    <el-button slot="reference" 
                    @click="goToDetail(scope.row.productCode)"
                    type="text" class="textBtn">
                      编辑
                    </el-button>
                    <el-popconfirm title="确定删除吗？"
                                   @onConfirm="delectProduct(scope.row.productCode)">
                      <el-button slot="reference" type="text" class="textBtn">
                        删除
                      </el-button>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </el-scrollbar>
            <div>
              <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                             :current-page.sync="queryInfo.currPage" :page-sizes="[10, 20, 30, 50]"
                             :page-size="queryInfo.pageSize" layout="total, sizes, prev, pager, next, jumper"
                             :total="total"></el-pagination>
            </div>
          </el-col>
        </el-row>
        <!--        </el-scrollbar>-->
      </div>
    </el-card>

    <!-- 导入弹窗 -->
    <el-dialog title="导入店内菜品" :visible.sync="importModal" :before-close="cancellation" width="800px">
      <el-row>
        <el-col :span="6">
          <el-input v-model="importForm.productName" @input="inputProductName" clearable placeholder="请输入菜品名称搜索"
                    style="margin: 20px 0"></el-input>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="width: 100%;">
        <el-col :span="4">
          <div class="importTypeBox">
            <div v-for="(item, index) in importTypeData" :key="index"
                 :class="index === importTypeIndex ? 'importActive' : ''" class="importTypeItem"
                 @click="switchType(item.categoryCode, index)">
              {{ item.categoryName }}
            </div>
          </div>
        </el-col>
        <el-col :span="20">
          <div class="dataBox">
            <el-table :data="importProductData" fit highlight-current-row style="width: 100%;margin-top: 0"
                      @selection-change="handleSelectionChange"
                      :row-key="row => {return row.productCode}" ref="multipleTable">
              <el-table-column type="selection" align="center" width="75" :reserve-selection="true">
              </el-table-column>
              <el-table-column label="名称" align="center" prop="productName">
              </el-table-column>
              <el-table-column label="单位" align="center" prop="unit">
              </el-table-column>
              <el-table-column label="售价" align="center" prop="normalPrice">
                <template slot-scope="scope">
                  <div>￥{{ scope.row.normalPrice }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-col>
      </el-row>
      <div class="selectBox">
        <div style="width: 100px;padding-top: 10px">已选择({{ multipleChoice.length }})：</div>
        <div class="selectContent">
          <span v-for="(item,index) in multipleChoice" class="selectItem"
                @click="deleteChoice(index)" :key="index">{{ item.productName }} ✖</span>
        </div>
        <div class="qingkong" @click="empty()">清空</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <div style="color: #f59a23">添加菜品</div>
        <div>
          <el-button class="dayin-column-btn" @click="cancellation">取 消</el-button>
          <el-button class="add-column-btn" @click="TrueImport">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      height: window.innerHeight - 206, //表格高度
      value: '',
      searchInput: '',
      tableData: [],
      typeList: [],
      importTypeData: [],  //导入弹窗商品分类列表
      importProductData: [],  //导入弹窗商品分类列表
      typeIndex: 0,
      importTypeIndex: 0,
      importModal: false, //导入弹窗
      importForm: {
        merchantCode: JSON.parse(localStorage.getItem('merchantCode')),
        productName: '',
        categoryCode: ''
      },
      multipleChoice: [], ///弹窗多选数据
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 10,
        //查询条件
        condition: {
          merchantCode: JSON.parse(localStorage.getItem('merchantCode')),
          name: '',
          categoryCode: ''
        }
      },
      userlist: [],
      total: 0,
    }
  },
  created () {
    this.getListData()
    this.getProductTypeData()
    window.addEventListener('resize', this.getHeight)
  },
  mounted () {
    this.loading = false
  },
  destroyed () {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    // 跳转编辑页
    goToDetail(code){
      this.$router.push('/eleWaimaiProduct/details?productCode='+code)
    },
    //关闭弹窗
    cancellation () {
      this.importModal = false
      this.$refs.multipleTable.clearSelection()
    },
    //弹窗搜索框输入
    inputProductName () {
      setTimeout(() => {
        this.getProductList()
      }, 500)
    },
    //删除商品
    delectProduct (productCode) {
      this.$http.post('/eleWaimaiProduct/delProductWithRelation', {
        productCode,merchantCode:localStorage.getItem('merchantCode')
      }).then(res => {
        if (res.data.code === 200) {
          this.getListData()
          this.$message.success('删除成功！')
        }
      })
    },
    //导入
    TrueImport () {
      this.$http.post('/eleWaimaiProduct/importMerchantProduct', {
        merchantProductList: this.multipleChoice
      }).then(res => {
        if (res.data.code === 200) {
          this.importModal = false
          this.getListData()
          this.getProductTypeData()
          this.$refs.multipleTable.clearSelection()
          this.importTypeIndex = 0
          this.$message.success('操作成功！')
        }
      })
    },
    //单个删除弹窗选项
    deleteChoice (index) {
      let row = this.multipleChoice[index]
      let rows =  this.importProductData.find(element => {
        console.log(element,row,element.id,row.id)
        return element.id === row.id
      })
      console.log(row,'this.multipleChoice[index]')
      console.log(rows,'清空')
      this.$refs.multipleTable.toggleRowSelection(rows, false)
      this.multipleChoice.splice(index, 1)
    },
    //清空弹窗选项
    empty () {
      this.$refs.multipleTable.clearSelection()
    },
    //打开导入弹窗
    toImport () {
      this.importModal = true
      this.getTypeList()
      this.getProductList()
    },
    //页面分类列表
    getProductTypeData () {
      this.$http.post('/eleWaimaiProductCategory/queryList', {
        merchantCode: JSON.parse(localStorage.getItem('merchantCode')),
        totalCategoryFlag: true
      }).then(res => {
        if (res.data.code === 200) {
          this.typeList = res.data.data
        }
      })
    },
    //导入菜品分类列表
    getTypeList () {
      this.$http.post('/merchantProductCategory/queryList', {
        merchantCode: JSON.parse(localStorage.getItem('merchantCode')),
        totalCategoryFlag: true
      }).then(res => {
        if (res.data.code === 200) {
          this.importTypeData = res.data.data
        }
      })
    },
    //导入菜品列表
    getProductList () {
      this.$http.post('/merchantProduct/queryList',
        this.importForm).then(res => {
        if (res.data.code === 200) {
          this.importProductData = res.data.data
        }
      })
    },
    //页面切换分类
    SelectProductType (code, index) {
      this.typeIndex = index
      this.queryInfo.condition.categoryCode = code
      this.getListData()
    },
    //弹窗切换分类
    switchType (code, index) {
      this.importTypeIndex = index
      this.importForm.categoryCode = code
      this.getProductList()
    },
    //弹窗多选
    handleSelectionChange (val) {
      this.multipleChoice = val
    },
    //条件查询
    search () {
      this.queryInfo.condition.id = this.searchInput
      this.getListData()
    },
    // 监听 pagesize改变的事件
    handleSizeChange (newSize) {
      this.queryInfo.pageSize = newSize
      this.getListData()
    },
    // 监听 页码值 改变事件
    handleCurrentChange (newSize) {
      this.queryInfo.currPage = newSize
      this.getListData()
    },
    getListData () {
      // 获取列表
      let that = this
      that.$http.post('/eleWaimaiProduct/list', that.queryInfo).then(function (response) {
        if (response.data.code == 200) {
          that.total = response.data.data.count
          that.queryInfo.currPage = response.data.data.currPage
          that.tableData = response.data.data.data
        }
      })
    },
    sequence () {
      return (this.queryInfo.currPage - 1) * this.queryInfo.pageSize + 1
    },
    // 监听表格高度
    getHeight () {
      this.height = window.innerHeight - 256
    },
  },
}
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}

.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;

    .el-select > .el-input {
      width: 200px;
    }

    .header-search-box .header-search-input {
      width: 325px;
    }

    input::placeholder {
      font-size: 12px;
    }

    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }

    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      // left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}

/deep/ .el-scrollbar__view {
  min-width: 100%;
}

/deep/ .el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}

/deep/ .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}

.typeBox {
  border-right: 1px solid #eee;
  height: 100%;
}

.typeItem {
  padding: 10px 20px;
  cursor: pointer;
  font-size: 14px;
}

.importTypeBox {
  height: 300px;
  overflow-y: scroll;
}

.importTypeItem {
  padding: 10px 20px;
}

.active {
  background-color: #fde7ca;
}

.importActive {
  background-color: #fde7ca;
}

.add-column-btn {
  background-color: #f59a23;
  color: #000000;
  border: none;
}

.dayin-column-btn {
  border: 1px solid #DCDFE6;
  background: transparent;
  color: #000000;
}

.dayin-column-btn:hover {
  background: #fde7ca;
  color: #000000;
}

.dayin-column-btn:active {
  background: #fde7ca;
  color: #000000;
  border: none;
}

.dataBox {
  max-height: 300px;
  overflow-y: scroll;
}

.selectBox {
  display: flex;
  align-items: flex-start;
  //margin-top: 20px;
  border-top: 1px solid #eee;
  //border-bottom: 1px solid #eee;
}

.selectContent {
  width: 80%;
  height: 80px;
  overflow-y: scroll;
  border-right: 2px solid #eee;
}

.selectItem {
  display: inline-block;
  background: #ededed;
  padding: 3px 5px;
  margin: 5px 5px;
  white-space: nowrap;
  cursor: pointer;
}

.qingkong {
  width: 70px;
  padding: 10px;
  color: #f59a23;
  cursor: pointer;
}

.dialog-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.textBtn {
  color: #f59a23;
  padding: 0 5px;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #f59a23;
  border-color: #f59a23;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #f59a23;
  border-color: #f59a23;
}

/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #f59a23;
  border-color: #f59a23;
}

/deep/.el-select-dropdown__item.selected{
  color: #f59a23;
}

/deep/ .el-dialog__body {
  padding: 0 30px;
  border-top: 2px solid #eee;
  border-bottom: 1px solid #eee;
}

///deep/.el-pagination.is-background .el-pager li:not(.is-disabled).is-active {
//  background-color: #f59a23 !important; //修改默认的背景色
//}
div::-webkit-scrollbar{
  display:none
}
</style>

